import { useEffect, useState } from "react";
import { List } from "antd";
import PropTypes from "prop-types";
import { FileTextOutlined } from "@ant-design/icons";

import { useAxiosPrivate } from "../../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../../store/session-store.js";

function ChatAppDocuments({ appId }) {
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const [chatDocuments, setChatDocuments] = useState([]);

  useEffect(() => {
    fetchDocuments();
  }, [sessionDetails]);

  const fetchDocuments = async () => {
    try {
      const requestOptions = {
        method: "GET",
        url: `/api/v1/unstract/${sessionDetails?.orgId}/app/documents/${appId}/`,
      };
      const res = await axiosPrivate(requestOptions);
      setChatDocuments(res.data);
    } catch (err) {
      // Todo: Show error alert
    }
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={chatDocuments}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={<FileTextOutlined />}
            title={item.file_name}
          />
        </List.Item>
      )}
    />
  );
}

ChatAppDocuments.propTypes = {
  appId: PropTypes.string.isRequired,
};
export { ChatAppDocuments };
